<template>
  <div v-if="show">
    <div
      v-if="!noOverlay || showManagerModal"
      class="app-cookie-policy-popup-overlay"
      :class="{ 'app-cookie-policy-popup-overlay--show-settings': showManagerModal }"
    />
    <AppCookiePolicyPopup @accept="handleAcceptAll" @manage="showManagerModal = true" />

    <AppModal
      v-model="showManagerModal"
      backdrop="static"
      :base-z-index="2010"
      class="app-cookie-policy-manager-modal"
      centered
      scrollable
      title="Manage cookies"
      title-centered
      transparent-backdrop
      @hidden="handleAfterCloseManagerModal"
    >
      <AppCookiePolicyManager :options="managerOptions" @save="handleSaveSettings" />
    </AppModal>
  </div>
</template>

<script>
import {
  managerOptions,
  areCookiePolicySettingsAccepted,
  storeCookiePolicySettings,
} from '@/helpers/privacyPolicyModal';
import { enableAnalyticsAfterConsent } from '@/helpers/ga/gaSend';
import AppCookiePolicyPopup from '@/components/AppCookiePolicyPopup.vue';
import AppCookiePolicyManager from '@/components/AppCookiePolicyManager.vue';
import AppModal from '@/components/modals/AppModal.vue';

export default {
  name: 'AppCookiePolicyPopupController',
  components: { AppModal, AppCookiePolicyManager, AppCookiePolicyPopup },

  data() {
    return {
      accepted: false,
      managerOptions,
      settings: {
        performanceAnalytics: false,
      },
      show: false,
      showManagerModal: false,
    };
  },
  computed: {
    noOverlay() {
      return this.$route.path.startsWith('/legal');
    },
  },

  mounted() {
    this.show = this.determineShowController();
  },

  methods: {
    determineShowController() {
      const accepted = areCookiePolicySettingsAccepted();
      if (accepted) {
        this.$store.dispatch('cookiePolicy/accept');
      }

      return !accepted;
    },
    handleAcceptAll() {
      for (const prop in this.settings) {
        this.settings[prop] = true;
      }
      this.storePolicySettings();
    },
    handleAfterCloseManagerModal() {
      if (this.accepted) {
        this.show = false;
      }
    },
    handleSaveSettings(settings) {
      this.settings = settings;
      this.storePolicySettings();
    },
    storePolicySettings() {
      this.accepted = true;
      this.$store.dispatch('cookiePolicy/accept');
      storeCookiePolicySettings(this.settings);

      if (this.settings.performanceAnalytics) {
        enableAnalyticsAfterConsent();
      }

      if (!this.showManagerModal) {
        this.show = false;
      }
      this.showManagerModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-cookie-policy-popup-overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: vars.$app-cookie-policy-popup-overlay-z-index;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: rgba(vars.$c-total-black, 0.5);

  &--show-settings {
    z-index: calc(vars.$app-cookie-policy-popup-overlay-z-index + 2);
  }
}

.app-cookie-policy-manager-modal.app-modal {
  ::v-deep {
    .modal-dialog {
      @media (min-width: vars.$mobile-break-point) {
        max-width: 580px;
      }
    }

    .modal-title {
      font-size: 18px;
      letter-spacing: 3px;
      text-transform: uppercase;
    }
  }
}
</style>
